export { default as EditCnbwColumnsComponent } from './edit-cnbw-columns.component';
export * from './edit-cnbw-columns.component';
